import { CASETAFEL_STAKEHOLDERS_RESOURCE } from '../resources/casetafel.stakeholders.resource';
import { CLARIFICATION_STAKEHOLDERS_RESOURCE } from '../resources/clarification.stakeholders.resource';
import { CONTACTMOMENT_STAKEHOLDERS_RESOURCE } from '../resources/contactmoments.stakeholders.resource';
import { DOSSIER_ACTIVITY_RESOURCE } from '../resources/dossier.activity.resource';
import { DOSSIER_ATTACHMENTS_RESOURCE } from '../resources/dossier.attachments.resource';
import { DOSSIER_COMMENTS_RESOURCE } from '../resources/dossier.comments.resource';
import { DOSSIER_CONTACTMOMENTS_RESOURCE } from '../resources/dossier.contactmoments.resource';
import { DOSSIER_CONTACTS_WORKED_FOR_SAME_SCHOOL_RESOURCE } from '../resources/dossier.contacts.worked.for.same.school.resource';
import { DOSSIER_OVERVIEW_SCHOOLS_RESOURCE } from '../resources/dossier.overview.schools.resource';
import { DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE } from '../resources/dossier.overview.stakeholders.resource';
import { DOSSIER_REQUEST_SCHOOLS_RESOURCE } from '../resources/dossier.request.schools.resource';
import { DOSSIER_STAKEHOLDER_CONTACTS_RESOURCE } from '../resources/dossier.stakeholder.contacts.resource';
import { DOSSIERS_RELATED_RESOURCE } from '../resources/dossiers.related.resource';
import { DOSSIERS_RESOURCE } from '../resources/dossiers.resource';
import { MEASURE_MOMENTS_RESOURCE } from '../resources/measure.moments.resource';
import { PROCEDURE_STAKEHOLDERS_RESOURCE } from '../resources/procedure.stakeholders.resource';

export const STAKEHOLDER_DOSSIER_PATHS = {
  CLARIFICATION: 'requestClarification',
  CASETABLE: 'caseTable',
  COMMISSION: 'commission',
  PROCEDURE: 'procedure',
  CONTACTMOMENTS: 'contactMoment',
  CONTACTMOMENTS_ADD: 'contactMoment_add'
};

export const STAKEHOLDER_ROLES_CLARIFICATION_OPTIONS = [
  { value: 'Gesprekspartner', label: 'Gesprekspartner' },
  { value: 'Vraagverhelderaar', label: 'Vraagverhelderaar' }
];

export const DOSSIER_TYPES = {
  PROGRAM: 'traject',
  FINANCED_PROGRAM: 'traject_met_toelage',
  ACTION: 'actie'
};

export const STAKEHOLDER_CASETAFEL_REPRESENTATIVE = 'Voorzitter';
export const STAKEHOLDER_ROLES_CASETAFEL_OPTIONS = [
  { value: STAKEHOLDER_CASETAFEL_REPRESENTATIVE, label: 'Voorzitter' },
  { value: 'Aanwezige', label: 'Aanwezige' }
];

export const STAKEHOLDER_ROLES_PROCEDURE_OPTIONS = [
  { value: 'Procesbegeleider', label: 'Procesbegeleider' },
  { value: 'Externe partner', label: 'Externe partner' },
  { value: 'Projectverantwoordelijke', label: 'Projectverantwoordelijke' },
  { value: 'Lid werkgroep', label: 'Lid werkgroep' }
];

export const STAKEHOLDER_ROLE_CONTACTMOMENT_OTHER = 'Andere';
export const STAKEHOLDER_ROLES_CONTACTMOMENTS_OPTIONS = [
  { value: 'Begeleider', label: 'Begeleider' },
  { value: 'Vraagverhelderaar', label: 'Vraagverhelderaar' },
  { value: 'Gesprekspartner VVH', label: 'Gesprekspartner VVH' },
  { value: 'Voorzitter casetafel', label: 'Voorzitter casetafel' },
  { value: 'Deelnemer casetafel', label: 'Deelnemer casetafel' },
  { value: 'Schoolmedewerker', label: 'Schoolmedewerker' },
  { value: STAKEHOLDER_ROLE_CONTACTMOMENT_OTHER, label: STAKEHOLDER_ROLE_CONTACTMOMENT_OTHER }
];

export const DOSSIER_RESOURCES = [
  DOSSIER_OVERVIEW_SCHOOLS_RESOURCE,
  DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE,
  DOSSIERS_RELATED_RESOURCE,
  PROCEDURE_STAKEHOLDERS_RESOURCE,
  MEASURE_MOMENTS_RESOURCE,
  CASETAFEL_STAKEHOLDERS_RESOURCE,
  CLARIFICATION_STAKEHOLDERS_RESOURCE,
  CONTACTMOMENT_STAKEHOLDERS_RESOURCE,
  DOSSIER_STAKEHOLDER_CONTACTS_RESOURCE,
  DOSSIER_CONTACTMOMENTS_RESOURCE,
  DOSSIER_ACTIVITY_RESOURCE,
  DOSSIER_REQUEST_SCHOOLS_RESOURCE,
  DOSSIERS_RESOURCE,
  DOSSIER_CONTACTS_WORKED_FOR_SAME_SCHOOL_RESOURCE,
  DOSSIER_ATTACHMENTS_RESOURCE,
  DOSSIER_COMMENTS_RESOURCE
];
